document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(event) {
    const btn = event.target.closest('[id^="BuyNowButton-"]');
    if (!btn) return;
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    // Locate form
    let productForm = btn.closest('form');
    if (!productForm) {
      const wrapper = btn.closest('product-form');
      if (wrapper) productForm = wrapper.querySelector('form');
    }
    if (!productForm) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      return;
    }
    const variantInput = productForm.querySelector('input[name="id"]');
    const variantId = variantInput ? variantInput.value : null;
    const quantityInput = productForm.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    if (!variantId) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      return;
    }
    const payload = { id: variantId, quantity: quantity };
    // selling plan (if any)
    const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value) {
      payload.selling_plan = sellingPlanInput.value;
    }
    // custom properties (if any)
    const propInputs = productForm.querySelectorAll('input[name^="properties["]');
    if (propInputs.length) {
      payload.properties = {};
      propInputs.forEach(el => {
        const m = el.name.match(/^properties\[(.*)\]$/);
        if (m) payload.properties[m[1]] = el.value;
      });
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => {
          const msg = err.description || err.message || 'Error adding to cart.';
          return Promise.reject(new Error(msg));
        });
      }
      return response.json();
    })
    .then(() => {
      window.location.href = '/checkout';
    })
    .catch(error => {
      const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
      const errorMessage = productForm.querySelector('.product-form__error-message');
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = error.message;
        errorWrapper.hidden = false;
      }
      btn.disabled = false;
      btn.classList.remove('is-loading');
    });
  });
});
